import { i18n as i18next } from 'i18next';
import { Namespace, useTranslation as useI18nTranslation, TFunction } from 'react-i18next';

export type UseTranslationInterfaceHookResponse<N extends Namespace, TKPrefix = undefined> = {
  t: TFunction<N, TKPrefix>;
  ct: TFunction<N, TKPrefix>;
  i18n: i18next;
  ready: boolean;
};

export type UseTranslationInterfaceResponse<N extends Namespace, TKPrefix = undefined> = (
  prefix: string,
) => UseTranslationInterfaceHookResponse<N, TKPrefix>;

export const useTranslation = (...namespaces: string[]) =>
  useI18nTranslation(['common', ...namespaces]);

export const useTranslationInterface: UseTranslationInterfaceResponse<string[], undefined> = (
  prefix,
) => {
  const { t, i18n, ready } = useTranslation(prefix);
  return {
    t: (name: Namespace, args?: any) => t(`${prefix}:${name}`, args),
    ct: (name: Namespace, args?: any) => t(`common:${name}`, args),
    i18n,
    ready,
  };
};

export const useCurrentLocale = () => {
  const { i18n } = useI18nTranslation();
  return {
    language: i18n?.language?.split('-')?.[0]?.toUpperCase(),
    locale: i18n?.language,
    changeLanguage: i18n?.changeLanguage,
  };
};

export const useCommonTranslations = () => useTranslation();
export const useSchemaValidationErrorTranslations = () => {
  const { t, i18n } = useTranslation('schemaValidationErrors');
  return {
    zt: (name: Namespace, args?: any) =>
      // Print the namespace if a translation doesn't exists
      i18n.exists(`schemaValidationErrors:${name}`)
        ? t(`schemaValidationErrors:${name}`, args)
        : name,
  };
};
